import { createFileRoute } from "@tanstack/react-router"
import { PricesPage } from "@/features/crawl-dashboard/PricesPage"

export const Route = createFileRoute("/crawl/prices")({
	component: PricesPage,
})
